// Colored brand-icon SVGs used by the in-app widget previews. These mirror the
// inline SVGs served from the production widget JS (see /app/backend/widgets/).
// Keep visually consistent so customers' preview matches the installed output.

const wrap = { display: "inline-block", verticalAlign: "-2px" };

export const BrowserIcon = ({ name, size = 14 }) => {
  const k = (name || "").toLowerCase().replace(/\s+/g, "");
  if (k.includes("chrome")) {
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label="Chrome">
        <circle cx="12" cy="12" r="11" fill="#fff" />
        <path d="M12 1a11 11 0 0 1 9.53 5.5H12a5.5 5.5 0 0 0-4.76 8.24L2.47 6.5A11 11 0 0 1 12 1z" fill="#EA4335" />
        <path d="M21.53 6.5A11 11 0 0 1 22 16.5L17.24 8.24A5.5 5.5 0 0 1 17.5 12H12l3 5.19A5.5 5.5 0 0 0 17.5 12h4.03A11 11 0 0 1 12 23l3-5.19z" fill="#FBBC05" />
        <path d="M2.47 6.5L7.24 14.74A5.5 5.5 0 0 0 12 17.5L9 22.69A11 11 0 0 1 2.47 6.5z" fill="#34A853" />
        <circle cx="12" cy="12" r="4" fill="#4285F4" />
      </svg>
    );
  }
  if (k.includes("firefox")) {
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label="Firefox">
        <defs>
          <radialGradient id="ffg2" cx="60%" cy="50%">
            <stop offset="0%" stopColor="#FFEA00" />
            <stop offset="40%" stopColor="#FF8800" />
            <stop offset="100%" stopColor="#E63E00" />
          </radialGradient>
        </defs>
        <circle cx="12" cy="12" r="11" fill="url(#ffg2)" />
        <path d="M5 8c1-3 4-5 7-4 2 1 3 3 2 5-1 1-3 0-3-2 0-1 1-2 2-2-3-1-7 1-8 5-1 4 2 8 6 8 4 0 7-3 7-7 0-1-1-3-2-3" fill="#fff" opacity=".85" />
      </svg>
    );
  }
  if (k.includes("safari")) {
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label="Safari">
        <circle cx="12" cy="12" r="11" fill="#1E90FF" />
        <circle cx="12" cy="12" r="9" fill="#fff" />
        <path d="M15 9l-2.2 3.8L9 15l2.2-3.8z" fill="#EA4335" />
        <path d="M9 15l3.8-2.2L15 9l-3.8 2.2z" fill="#fff" stroke="#EA4335" strokeWidth=".3" />
        <circle cx="12" cy="12" r=".8" fill="#333" />
      </svg>
    );
  }
  if (k.includes("edge")) {
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label="Edge">
        <defs>
          <linearGradient id="edg2" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#0078D4" />
            <stop offset="100%" stopColor="#50E6FF" />
          </linearGradient>
        </defs>
        <path d="M3 14a9 9 0 0 1 17-4c-3-3-9-2-11 2-1 2 0 4 2 5-3 0-7-1-8-3z" fill="url(#edg2)" />
        <path d="M6 19a9 9 0 0 0 14-2c-2 1-6 1-8-1-2-1-2-4 0-5-3 0-6 1-7 4-1 2 0 3 1 4z" fill="#0F62FE" opacity=".85" />
      </svg>
    );
  }
  if (k.includes("opera")) {
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label="Opera">
        <circle cx="12" cy="12" r="11" fill="#FF1B2D" />
        <ellipse cx="12" cy="12" rx="4.5" ry="8.5" fill="#fff" />
      </svg>
    );
  }
  if (k.includes("ie") && !k.includes("vivaldi")) {
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label="Internet Explorer">
        <circle cx="12" cy="12" r="11" fill="#1EBBEE" />
        <path d="M3.2 15.5c4.5 3.2 12 3.6 17.4.4" stroke="#FDB813" strokeWidth="2.2" fill="none" strokeLinecap="round" />
        <text x="12" y="17.2" fontFamily="Georgia,Times,serif" fontSize="14" fontWeight="700" fill="#fff" textAnchor="middle">e</text>
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label={name || "Browser"}>
      <circle cx="12" cy="12" r="10" fill="none" stroke="#6b7280" strokeWidth="1.5" />
      <ellipse cx="12" cy="12" rx="4" ry="10" fill="none" stroke="#6b7280" strokeWidth="1.2" />
      <path d="M2 12h20M3.5 7h17M3.5 17h17" stroke="#6b7280" strokeWidth="1.2" fill="none" />
    </svg>
  );
};

export const OsIcon = ({ name, size = 14 }) => {
  const k = (name || "").toLowerCase().replace(/\s+/g, "");
  if (k.includes("windows")) {
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label="Windows">
        <path d="M3 5l8-1v8H3z M12 4l9-1v10h-9z M3 13h8v8l-8-1z M12 13h9v9l-9-1z" fill="#00ADEF" />
      </svg>
    );
  }
  if (k === "macos" || k === "osx" || (k.includes("mac") && !k.includes("ios"))) {
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label="macOS">
        <path d="M17 13c0-3 2-4 2-4-1-2-3-2-4-2-2 0-3 1-4 1-1 0-2-1-4-1-2 0-4 1-5 4-2 5 1 11 3 11 1 0 2-1 4-1 1 0 2 1 4 1s3-2 4-3c1-2 0-6 0-6z M14 4c1-1 1-2 1-3-1 0-2 1-3 2 0 1 1 2 2 1z" fill="#555" />
      </svg>
    );
  }
  if (k.includes("linux") || k.includes("ubuntu")) {
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label="Linux">
        <ellipse cx="12" cy="14" rx="6" ry="8" fill="#222" />
        <ellipse cx="9.5" cy="10" rx="1.8" ry="2.2" fill="#fff" />
        <ellipse cx="14.5" cy="10" rx="1.8" ry="2.2" fill="#fff" />
        <circle cx="10" cy="10.5" r=".8" fill="#000" />
        <circle cx="14" cy="10.5" r=".8" fill="#000" />
        <path d="M10 13 Q12 14 14 13 L13 14.5 Q12 15 11 14.5 Z" fill="#FCC91F" />
        <path d="M9 19 Q12 21 15 19 L14 21 Q12 22 10 21 Z" fill="#FCC91F" />
      </svg>
    );
  }
  if (k.includes("android")) {
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label="Android">
        <path d="M5 12a7 7 0 0 1 14 0v6H5z" fill="#3DDC84" />
        <circle cx="9" cy="11" r="1" fill="#fff" />
        <circle cx="15" cy="11" r="1" fill="#fff" />
        <rect x="3" y="12" width="2" height="6" rx="1" fill="#3DDC84" />
        <rect x="19" y="12" width="2" height="6" rx="1" fill="#3DDC84" />
      </svg>
    );
  }
  if (k === "ios" || k.includes("iphone") || k.includes("ipad")) {
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label="iOS">
        <path d="M17 13c0-3 2-4 2-4-1-2-3-2-4-2-2 0-3 1-4 1-1 0-2-1-4-1-2 0-4 1-5 4-2 5 1 11 3 11 1 0 2-1 4-1 1 0 2 1 4 1s3-2 4-3c1-2 0-6 0-6z M14 4c1-1 1-2 1-3-1 0-2 1-3 2 0 1 1 2 2 1z" fill="#000" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label={name || "OS"}>
      <rect x="3" y="4" width="18" height="14" rx="2" fill="none" stroke="#6b7280" strokeWidth="1.4" />
      <rect x="3" y="4" width="18" height="3" rx="2" fill="#6b7280" />
    </svg>
  );
};

// Monochrome device icon (item 7): infer from `device` (mobile/tablet/desktop) or OS
export const DeviceIcon = ({ device, os, size = 13 }) => {
  const d = String(device || "").toLowerCase();
  const o = String(os || "").toLowerCase();
  const isMobile = d === "mobile" || o.includes("android") || o.includes("ios") || o.includes("iphone");
  const isTablet = d === "tablet" || o.includes("ipad");
  if (isMobile) {
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label="Mobile">
        <rect x="7" y="2" width="10" height="20" rx="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="12" cy="19" r=".9" fill="currentColor" />
      </svg>
    );
  }
  if (isTablet) {
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label="Tablet">
        <rect x="4" y="2" width="16" height="20" rx="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="12" cy="19.5" r=".8" fill="currentColor" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label="Desktop">
      <rect x="2" y="4" width="20" height="13" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <path d="M9 20h6M12 17v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

// Bot icon — red accent so it's unmistakable when it appears alongside the
// colored browser/OS/device icons. Size bumped 13→15 and now uses an
// explicit red fill/stroke (overrides any `color` prop on the parent).
export const BotBadge = ({ size = 15 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} style={wrap} aria-label="Bot visit">
    <rect x="3" y="8" width="18" height="12" rx="3" fill="#fee2e2" stroke="#dc2626" strokeWidth="1.7" />
    <circle cx="8.5" cy="13.5" r="1.6" fill="#dc2626" />
    <circle cx="15.5" cy="13.5" r="1.6" fill="#dc2626" />
    <path d="M10 17h4" stroke="#dc2626" strokeWidth="1.6" strokeLinecap="round" />
    <path d="M12 3v4" stroke="#dc2626" strokeWidth="1.7" strokeLinecap="round" />
    <circle cx="12" cy="2.5" r="1.4" fill="#dc2626" />
    <rect x="1" y="11" width="2.2" height="6" rx="1.1" fill="#dc2626" />
    <rect x="20.8" y="11" width="2.2" height="6" rx="1.1" fill="#dc2626" />
  </svg>
);
